{
  "valid": "Valid",
  "expired": "Expired certificate",
  "month": "{n} month | {n} months",
  "days": "{n} day left | {n} days left",
  "keystore": {
    "generateSelfSignedCertificate": "Generate self-signed certificate",
    "generateCSR": "Generate CSR",
    "csrRequiresUploadCertificate": "This certificate signing request requires to upload a certificate",
    "list": {
      "action": {
        "delete": {
          "description": "The certificate {alias} will be deleted."
        }
      }
    },
    "updateCertificate": "Update certificate",
    "csr": "CSR",
    "certificate": "Certificate",
    "error": {
      "csr": {
        "loading": "Fail to load the CSR"
      }
    },
    "automaticRenewal": {
      "label": "Automatic certificate renewal",
      "csr": {
        "info": "The automatic renewal will run daily if a PKI configuration is associated with this certificate. You can also trigger the renewal immediately by pressing the button.",
        "buttonLabel": "Generate certificate"
      }
    },
    "filters": {
      "searchByAlias": "Search by alias"
    }
  },
  "download": "Download certificate",
  "delete": "Delete certificate",
  "noCertificate": "No certificate available",
  "tag": "Tag",
  "tags": {
    "label": "Tags",
    "empty": "No tag found"
  },
  "alias": "Alias",
  "expiration": {
    "timestamp": {
      "label": "Expiration date",
      "labelColon": "Expiration date:"
    }
  },
  "list": {
    "column": {
      "timestamp": {
        "format": "YYYY-MM-DD at hh:mm A"
      }
    },
    "action": {
      "delete": {
        "description": "The certificate {alias} will be deleted."
      }
    }
  },
  "form": {
    "serialNumber": "Serial number",
    "organizationUnit": "Organization unit",
    "organization": "Organization",
    "locality": "Locality",
    "region": "Region",
    "country": "Country",
    "tags": {
      "placeholder": "Select",
      "remove": {
        "tooltip": "Click to remove the tag"
      }
    },
    "associatedPkiConfiguration": "Associated PKI configuration",
    "cn": "CN",
    "email": "email"
  },
  "validation": {
    "alias": {
      "required": "The alias is requied.",
      "invalid": "The alias must contain only lower case letters in latin alphabet, digits, hyphens, underscores or spaces."
    },
    "cn": "The CN is required.",
    "email": "The email is required.",
    "certificate": {
      "invalid": "The certificate does not seem to be valid.",
      "extension": "The certificate does not have the right file extension.",
      "fileEmpty": "The certificate file must not be empty.",
      "fileSize": "The certificate file must be less than 750MB in size."
    },
    "associatedPkiConfiguration": "Warning : The automatic certificate renewal will not be performed as long as the certificate/CSR will not be associated with a PKI configuration."
  },
  "error": {
    "certificate": {
      "loading": "Fail to load the certificate"
    }
  },
  "truststore": {
    "uploadCertificate": "Upload certificate",
    "editCertificate": "Edit the certificate"
  },
  "filters": {
    "searchByAlias": "Search by alias"
  },
  "cancelAction": {
    "confirm": {
      "message": "Do you confirm cancelling the operation? All data will be lost."
    }
  },
  "chain": {
    "label": "Certificate chain",
    "level": "level {level}"
  },
  "downloadCSR": "Download CSR",
  "subject": {
    "label": "Subject"
  },
  "subjectAlternativeName": {
    "label": "Subject Alternative Name",
    "add": "Add SAN",
    "empty": "There is no SAN defined.",
    "delete": "Delete the SAN",
    "noValue": "Missing value",
    "unknownError": "An unknown error occurred during the verification",
    "type": "Type",
    "value": "Value",
    "2": {
      "label": "DNS",
      "labelColon": "DNS:",
      "invalidFormat": "The value must be a valid DNS"
    },
    "7": {
      "label": "IP",
      "labelColon": "IP",
      "invalidFormat": "The value must be a valid IP address"
    }
  },
  "extendedKeyUsage": {
    "label": "Extended Key Usage",
    "empty": "There is no EKU defined.",
    "1": "Server Authentication",
    "2": "Client Authentication"
  },
  "tab": {
    "keystore": "Keystore",
    "truststore": "Truststore"
  },
  "trustChain": {
    "label": "Chain of trust"
  },
  "start": {
    "timestamp": {
      "labelColon": "Start validity date:"
    }
  }
}
